import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FunctionsStorageService {
  public responseSuccessFn: (response: any) => any;
}
